import styled from 'styled-components';

export const SummaryRow = styled.tr`
	background-color: #2498f743 !important;
`;
